import { Amplify } from 'aws-amplify';
import { awsConfig } from './aws-config';

Amplify.configure({
  Auth: {
    Cognito: {
      region: awsConfig.region,
      userPoolId: awsConfig.userPoolId,
      userPoolClientId: awsConfig.userPoolWebClientId,
      identityPoolId: awsConfig.identityPoolId,
      loginWith: {
        email: true
      }
    }
  }
});

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
